import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { CalendarService } from './calendar.service';
import { CalendarConfig, ICalendarsConfigurationData } from '@bciti/types';

@Injectable({
    providedIn: 'root',
})
export class CalendarServiceImpl implements CalendarService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    getCalendarConfiguration(orgTag: string): Observable<CalendarConfig<any>[]> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/calendar/${orgTag}`).pipe(map((config) => config as CalendarConfig<any>[]))));
    }

    updateCalendarConfiguration(orgTag: string, config: ICalendarsConfigurationData): Observable<ICalendarsConfigurationData> {
        return this.store.select(environmentSelector).pipe(
            switchMap((env) =>
                this.http
                    .patch(`${env.baseUrl}/cerberus/calendar/${orgTag}`, config, {
                        headers: { 'x-organisation': String(orgTag) },
                    })
                    .pipe(map((res) => res as ICalendarsConfigurationData)),
            ),
        );
    }

    deleteCalendarConfiguration(orgTag: string | number): Observable<any> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.delete(`${env.baseUrl}/cerberus/calendar/${orgTag}`).pipe(map((res) => res))));
    }

    synchronizeOrgCalendar(orgTag: string): Observable<string> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/calendar/synchro/${orgTag}`).pipe(map((res) => res as string))));
    }
}

export const CALENDAR_SERVICE_PROVIDER = {
    provide: CalendarService,
    useClass: CalendarServiceImpl,
};
